import type { NilHundredResponseNil100FilterResponseRelatedPagedData } from '@on3/api';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { Link } from 'components/Link';
import { Nil100 } from 'components/Svg/Nil100';

import styles from './Nil100Module.module.scss';
import { Nil100ModuleItems } from './Nil100ModuleItems';

export const Nil100Module = ({
  list,
}: NilHundredResponseNil100FilterResponseRelatedPagedData) => {
  const { currentSite } = useSite();

  const primaryColor = currentSite?.organization?.primaryColor || '#fe3b1f';

  return (
    <section className={styles.block}>
      <h2 aria-hidden={true} hidden>
        NIL 100
      </h2>

      <div
        className={styles.logos}
        style={{ borderBottom: `2px solid ${primaryColor}` }}
      >
        <Nil100 className={styles.nilLogo} fill={primaryColor} />
      </div>

      <ol className={styles.list}>
        {list?.map(
          (item) =>
            item.person && (
              <Nil100ModuleItems {...item} key={item.person?.key} />
            ),
        )}
      </ol>

      <footer className={styles.links}>
        <Link href="/nil/rankings/player/nil-valuations/">Complete List</Link>
        <Link href="/nil/news/about-on3-nil-valuation-per-post-value/">
          About
        </Link>
      </footer>
    </section>
  );
};
